<app-navbar title="Extrato" />

<div class="container m-auto py-8 px-4 overflow-y-auto scrollbar-hide max-h-[calc(100vh-5rem)]">
  <p-tabs [lazy]="true" [value]="tabSelected()" (valueChange)="updateParams({ tab: $event })">
    <p-tablist>
      <p-tab value="general">Visão Geral</p-tab>
      @for (account of metrics()?.contas_vinculadas?.items; track account.id) {
        <p-tab [value]="account.id!">{{ account.nome }}</p-tab>
      }
    </p-tablist>
    <p-tabpanels>
      <p-tabpanel value="general">
        <ng-container [ngTemplateOutlet]="general" />
      </p-tabpanel>
      @for (account of metrics()?.contas_vinculadas?.items; track account.id) {
        <p-tabpanel [value]="account.id!">
          <ng-container [ngTemplateOutlet]="accountItem" [ngTemplateOutletContext]="{ account: account }" />
        </p-tabpanel>
      }
    </p-tabpanels>
  </p-tabs>
</div>

<ng-template #general>
  <section class="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-4 mt-12">
    <div class="col-span-1 lg:col-span-2 xl:col-span-1 2xl:col-span-2">
      <app-header-card
        icon="fa-solid fa-sack-dollar"
        [content]="metrics()?.saldo_atual | currency"
        descriptionLight="Saldo total consolidado"
        [loading]="loading()"
      />
    </div>
    <div class="col-span-1">
      <app-header-card
        icon="fa-solid fa-gifts"
        [content]="metrics()?.entradas_periodo| currency"
        descriptionDark="Entradas no mês"
        [footerDark]="formatMetricsPeriod()"
        [loading]="loading()"
      />
    </div>
    <div class="col-span-1">
      <app-header-card
        icon="fa-solid fa-gifts"
        [content]="metrics()?.saidas_periodo| currency"
        descriptionDark="Saídas do mês"
        [footerDark]="formatMetricsPeriod()"
        [loading]="loading()"
      />
    </div>
  </section>
  <section class="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-4 mt-8">
    @if (loading()) {
      @for (item of [1,2,3]; track item) {
        <div class="w-full rounded-2xl bg-white border border-gray-200 space-y-4 p-6 col-span-1">
          <div class="w-full pl-3 border-l-3 border-background-dark text-xl font-semibold text-zinc-900">
            <p-skeleton height="1rem"></p-skeleton>
          </div>
          <div class="w-full space-y-3">
            <div>
              <p-skeleton height="1rem"></p-skeleton>
            </div>
            <div class="mt-4">
              <p-skeleton height="2.5rem"></p-skeleton>
            </div>
          </div>
          <p-divider />
          <div class="w-full space-y-3">
            <div>
              <p-skeleton height="1rem"></p-skeleton>
            </div>
            <div class="mt-4">
              <p-skeleton height="2.5rem"></p-skeleton>
            </div>
          </div>
          <p-divider />
          <div class="w-full space-y-3">
            <div>
              <p-skeleton height="1rem"></p-skeleton>
            </div>
            <div class="mt-4">
              <p-skeleton height="2.5rem"></p-skeleton>
            </div>
          </div>
          <p-divider />
          <div class="w-full space-y-3">
            <div>
              <p-skeleton height="1rem"></p-skeleton>
            </div>
            <div class="mt-4">
              <p-skeleton height="2.5rem"></p-skeleton>
            </div>
            <div>
              <p-skeleton height="1rem"></p-skeleton>
            </div>
          </div>
        </div>
      }
    }
    @for (account of metrics()?.contas_vinculadas?.items; track account.id) {
      <div class="w-full rounded-2xl bg-white border border-gray-200 space-y-4 p-6 col-span-1">
        <div class="w-full pl-3 border-l-3 border-background-dark text-xl font-semibold text-zinc-900">
          {{ account.nome }}
        </div>
        <div class="w-full space-y-3">
          <span class="text-sm text-zinc-400">Saldo atual</span>
          <div class="text-2xl font-semibold text-zinc-900">{{ account.saldo_atual | currency }}</div>
        </div>
        <p-divider />
        <div class="w-full space-y-4">
          <span class="text-sm text-zinc-400">Entradas</span>
          <div class="text-2xl font-semibold text-zinc-900">{{ account.entradas_periodo | currency }}</div>
        </div>
        <p-divider />
        <div class="w-full space-y-4">
          <span class="text-sm text-zinc-400">Saídas</span>
          <div class="text-2xl font-semibold text-zinc-900">{{ account.saidas_periodo | currency }}</div>
        </div>
        <p-divider />
        <div class="w-full space-y-4">
          <span class="text-sm text-zinc-400">Último lançamento</span>
          <div class="text-2xl font-semibold text-zinc-900">{{ account.ultimo_lancamento.data }}</div>
          <span class="text-sm text-zinc-400">{{ account.ultimo_lancamento.descricao }}</span>
        </div>
        <p-button styleClass="min-w-48">
          <span class="font-bold text-sm" (click)="tabSelected.set(account.id!); updateParams({ tab: account.id! })">Ver lançamentos</span>
        </p-button>
      </div>
    }
  </section>
</ng-template>

<ng-template #accountItem let-account="account">
  <div class="p-4 bg-white shadow-lg rounded-2xl h-full grid grid-cols-1 xl:grid-cols-2">
    <div class="flex flex-col md:flex-row flex-1 gap-8">
      @if (loading()) {
        <div class="w-full md:max-w-48">
          <p-skeleton shape="circle" size="10rem" />
        </div>
        <div class="space-y-4 w-full flex flex-col justify-center align-center pr-4">
          <div class="w-full">
            <p-skeleton height="1.5rem" />
          </div>
          <div class="w-full flex items-center gap-4">
            <div class="w-full space-y-1 pl-4 border-l-3 border-background-dark">
              <div class="w-full">
                <p-skeleton height="1.5rem" />
              </div>
              <div class="w-full">
                <p-skeleton height="1.5rem" />
              </div>
              <div class="w-full">
                <p-skeleton height="1.5rem" />
              </div>
            </div>
            <div class="w-full space-y-1 pl-4 border-l-3 border-background-dark">
              <div class="w-full">
                <p-skeleton height="1.5rem" />
              </div>
              <div class="w-full">
                <p-skeleton height="1.5rem" />
              </div>
              <div class="w-full">
                <p-skeleton height="1.5rem" />
              </div>
            </div>
          </div>
        </div>
      }
      @else {
        <div class="w-full md:max-w-48">
          <p-chart
            type="doughnut"
            [data]="accountsChartData()[account.id]"
            [options]="accountOptions()"
            class="w-full max-h-80"
          />
        </div>
        <div class="space-y-4 w-full flex flex-col justify-center align-center">
          <div class="text-xl text-zinc-900 font-semibold">Resumo das transações</div>
          <div class="flex items-center gap-4">
            <div class="space-y-1 pl-4 border-l-3 border-background-dark">
              <div class="text-zinc-900 font-semibold">Entradas</div>
              <div class="text-zinc-500">{{ account.entradas_periodo_qtd }} lançamentos</div>
              <div class="text-zinc-900 font-bold">{{ account.entradas_periodo | currency }}</div>
            </div>
            <div class="space-y-1 pl-4 border-l-3 border-background-dark">
              <div class="text-zinc-900 font-semibold">Saídas</div>
              <div class="text-zinc-500">{{ account.saidas_periodo_qtd }} lançamentos</div>
              <div class="text-zinc-900 font-bold">{{ account.saidas_periodo | currency }}</div>
            </div>
          </div>
        </div>
      }
    </div>
    <div class="flex-1 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
      @if (loading()) {
        <div class="w-full space-y-1 flex flex-col items-start justify-start">
          <p-skeleton height="1.5rem" />
          <p-skeleton height="2rem" />
        </div>
        <div class="w-full space-y-1 flex flex-col items-start justify-start">
          <p-skeleton height="1.5rem" />
          <p-skeleton height="2rem" />
        </div>
        <div class="w-full space-y-1 flex flex-col items-start justify-start">
          <p-skeleton height="1.5rem" />
          <p-skeleton height="2rem" />
        </div>
        <div class="w-full space-y-1 flex flex-col items-start justify-start">
          <p-skeleton height="1.5rem" />
          <p-skeleton height="2rem" />
        </div>
        <div class="w-full space-y-1 flex flex-col items-start justify-start col-span-2">
          <p-skeleton height="1.5rem" />
          <p-skeleton height="2rem" />
        </div>
      } @else {
        <div class="space-y-1 flex flex-col items-start justify-start">
          <div class="text-sm text-zinc-500">Total de registros</div>
          <div class="text-2xl text-zinc-900 font-bold">{{ account.total_registros }}</div>
        </div>
        <div class="space-y-1 flex flex-col items-start justify-start">
          <div class="text-sm text-zinc-500">Saldo atual</div>
          <div class="text-2xl text-zinc-900 font-bold">{{ account.saldo_atual | currency }}</div>
        </div>
        <div class="space-y-1 flex flex-col items-start justify-start">
          <div class="text-sm text-zinc-500">Entradas</div>
          <div class="text-2xl text-zinc-900 font-bold">{{ account.entradas_periodo | currency }}</div>
        </div>
        <div class="space-y-1 flex flex-col items-start justify-start">
          <div class="text-sm text-zinc-500">Saídas</div>
          <div class="text-2xl text-zinc-900 font-bold">{{ account.saidas_periodo | currency }}</div>
        </div>
        <div class="space-y-1 flex flex-col items-start justify-start col-span-1 sm:col-span-2">
          <div class="text-sm text-zinc-500">Último lançamento</div>
          <div class="text-2xl text-zinc-900 font-bold">{{ account.ultimo_lancamento.data }}</div>
          <div class="text-sm text-zinc-500">{{ account.ultimo_lancamento.descricao }}</div>
        </div>
      }
    </div>
  </div>
  <div class="p-4 bg-white shadow-lg rounded-2xl h-full w-full mt-8">
    <app-table-statement-account
      [loading]="loading()"
      [cashier_account_id]="account.id"
      (export)="export($event)"
      (edit)="openDialog($event)"
      (delete)="delete($event)"
    />
  </div>
</ng-template>

<p-dialog
  [visible]="statementDialog()"
  [maximizable]="true"
  [modal]="true"
  [style]="{ width: '56rem' }"
  [closable]="false"
>
  <ng-template #header>
    <div class="w-full items-center justify-center">
      <h1 class="text-2xl text-zinc-900 font-bold">{{ statementDialogTitle() }}</h1>
    </div>
  </ng-template>

  <form [formGroup]="statementForm" class="grid grid-cols-4 gap-4">

    <div class="flex flex-col justify-start gap-1 mb-4 col-span-4">
      <label for="cashier_account_id" class="font-semibold">Conta</label>
      <p-select
        id="cashier_account_id"
        [options]="metrics()?.contas_vinculadas?.items"
        formControlName="cashier_account_id"
        optionLabel="nome"
        [filter]="true"
        filterBy="nome"
        [showClear]="true"
        placeholder="Escolha uma conta"
        optionValue="id"
        [invalid]="statementForm.get('cashier_account_id')?.dirty && statementForm.get('cashier_account_id')?.errors"
      >
        <ng-template let-account #item>
            <div>{{ account.nome }}</div>
        </ng-template>
      </p-select>
      @if (statementForm.get('cashier_account_id')?.dirty && statementForm.get('cashier_account_id')!.hasError('required')) {
        <p-message severity="error" variant="simple" size="small">Selecione uma conta</p-message>
      }
    </div>
    <div class="flex flex-col justify-start gap-1 mb-4 col-span-2">
      <label for="value" class="font-semibold">Valor</label>
      <p-inputnumber
        id="value"
        mode="currency"
        currency="BRL"
        locale="pt-BR"
        formControlName="value"
        [invalid]="statementForm.get('value')?.dirty && statementForm.get('value')?.errors"
      />
      @if (statementForm.get('value')?.dirty && statementForm.get('value')!.hasError('required')) {
        <p-message severity="error" variant="simple" size="small">Insira o valor do lançamento</p-message>
      }
    </div>
    <div class="flex flex-col justify-start gap-1 mb-4 col-span-2">
      <label for="launch_at" class="font-semibold">Data lançamento</label>
      <p-datepicker
        formControlName="launch_at"
        dateFormat="dd/mm/yy"
        [iconDisplay]="'input'"
        [showIcon]="true"
        inputId="launch_at"
        appendTo="body"
        [showTime]="true"
        hourFormat="24"
        [invalid]="statementForm.get('launch_at')?.dirty && statementForm.get('launch_at')?.errors"
      />
      @if (statementForm.get('launch_at')?.dirty && statementForm.get('launch_at')!.hasError('required')) {
        <p-message severity="error" variant="simple" size="small">Data do lançamento é obrigatória</p-message>
      }
    </div>
    <div class="flex flex-col justify-start gap-1 mb-4 col-span-4">
      <label for="description" class="font-semibold">Descrição</label>
      <textarea id="description" rows="5" pTextarea formControlName="description"></textarea>
    </div>
    @if (statementForm.get('responsible')?.value) {
      <div class="flex flex-col justify-start gap-1 mb-4 col-span-2">
        <label for="value" class="font-semibold">Responsável</label>
        <input type="text" pInputText formControlName="responsible" />
      </div>
      <div class="flex flex-col justify-start gap-1 mb-4 col-span-2">
        <label for="created_at" class="font-semibold">Criado em</label>
        <p-datepicker dateFormat="dd/mm/yy" formControlName="created_at" [iconDisplay]="'input'" [showIcon]="true" inputId="created_at" appendTo="body" [showTime]="true" hourFormat="24" />
      </div>
    }
  </form>
  <ng-template #footer>
    <p-button label="Cancelar" [text]="true" severity="secondary" (click)="closeDialog(); $event.stopPropagation()" />
    <p-button label="Salvar" (click)="submitDialog()" />
  </ng-template>
</p-dialog>
